<template>
  <div class="admission-list-for-multiple-play-date-event">
    <div id="search-form-box">
      <search-form-box :main_event_id="main_event_id" :main_event_title="main_event_title" :play_dates="play_dates" :ticket_types="ticket_types" :get_audiences_path="get_audiences_path"> </search-form-box>
    </div>
    <div class="loading-box" v-if="showLoading">
      <loading></loading>
    </div>
    <div id="audience-list-table-for-multiple-play-date-event">
      <audience-list-table-for-multiple-play-date-event
        :get_audiences_path="get_audiences_path"
        :event_use_introducer="event_use_introducer"
        :event_introducer_text="event_introducer_text"
        :event_questionnaires="event_questionnaires"
        :use_introducer_tell="use_introducer_tell"
        :use_introducer_name="use_introducer_name"
        :use_introducer_adress="use_introducer_adress"
        :send_csv_path="send_csv_path"
        :main_event_title="main_event_title"
        :send_pdf_path="send_pdf_path"
        :main_event_id="main_event_id"
        :eventer_mail="eventer_mail"
        :admission_accept_path="admission_accept_path"
        :admission_unaccept_path="admission_unaccept_path"
        :can_action_cable="can_action_cable"
        @close-loading="closeLoading"
        :is_assistant_page="is_assistant_page"
      ></audience-list-table-for-multiple-play-date-event>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    main_event_id: { type: Number, required: true },
    main_event_title: { type: String, required: true },
    play_dates: { type: Array, required: true },
    ticket_types: { type: Array, required: true },
    get_audiences_path: { type: String, required: true },
    event_use_introducer: { type: Boolean, required: true },
    event_introducer_text: { type: String, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    send_csv_path: { type: String, required: true },
    send_pdf_path: { type: String, required: true },
    eventer_mail: { type: String },
    admission_accept_path: { type: String, required: true },
    admission_unaccept_path: { type: String, required: true },
    can_action_cable: { type: Boolean, required: true },
    is_assistant_page: { type: Boolean, required: true, default: false }
  },
  data() {
    return {
      room: -1,
      showLoading: true,
    };
  },
  created() {
    try {
      // actioncableの使用可否
      if (this.can_action_cable) {
        // actioncable設定
        this.messageChannel = App.cable.subscriptions.create(
          {
            channel: 'RoomChannel',
            room: 'E' + this.main_event_id,
          },
          {
            // サーバに接続
            connected: () => {
              this.$store.commit('actioncable/setConnectedOk');
            },
            // サーバから切断
            disconnected: () => {
              this.$store.commit('actioncable/setConnectedNg');
              this.messageChannel.unsubscribe();
              clearActioncableConnection();
            },
            // サーバからbroadcastがあった
            received: (data) => {
              this.$store.commit('actioncable/setConnectedOk');
              this.$store.commit('audience/setAudienceForce', data.data.data);
              if (data.data.data.admission == true) {
                this.$store.commit('audience/countupAdmittedAudiencesCount', data.data.data.volume);
              } else {
                this.$store.commit('audience/countdownAdmittedAudiencesCount', data.data.data.volume);
              }
            },
            // サーバから拒否された
            rejected: () => {
              this.$store.commit('actioncable/setConnectedNg');
              this.messageChannel.unsubscribe();
              clearActioncableConnection();
            },
          }
        );
      } else {
        this.$store.commit('actioncable/setConnectedNonTarget');
      }
    } catch (e) {
      this.$store.commit('actioncable/setConnectedNg');
      clearActioncableConnection();
    }
  },
  methods: {
    closeLoading() {
      this.showLoading = false;
    },
  },
};

// actioncableのconnectionクリア
function clearActioncableConnection() {
  let subscriptions = App.cable.subscriptions['subscriptions'];
  subscriptions.forEach(function (subscription) {
    App.cable.subscriptions.remove(subscription);
  });
  WebSocket = null;
}
</script>

<style lang="scss" scoped>
.loading-box {
  background-color: #000;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;

  .pg-performer-events--loader {
    position: fixed;
    top: 25%;
    left: 50%;
    z-index: 9999;
  }
}
</style>
